import {BaseSignableDocuments} from "./SignableDocuments";

export class SignableOfferDocuments extends BaseSignableDocuments
{
    constructor() {
        super('offers');
    }

    forOffer(offer_id) {
        return this.forModel(offer_id)
    }
}

export let SignableOfferDocumentsResource = new SignableOfferDocuments()